import { createFileRoute } from "@tanstack/react-router";
import { seo, breadcrumbScript } from "@/lib/seo";
import { LegalCard, LegalPage } from "@/components/app/legal-page";

const DESC =
  "Refund policy for The Quantum Minds digital subscriptions, duplicate payments and failed transactions.";

export const Route = createFileRoute("/refund")({
  head: () => ({
    ...seo({
      title: "Refund Policy — The Quantum Minds",
      description: DESC,
      path: "/refund",
    }),
    scripts: [
      breadcrumbScript([
        { name: "Home", path: "/" },
        { name: "Refund Policy", path: "/refund" },
      ]),
    ],
  }),
  component: RefundPage,
});

function RefundPage() {
  return (
    <LegalPage title="Refund Policy">
      <LegalCard
        heading="Non-Refundable Premium Access"
        points={[
          "Digital subscriptions and premium access are generally non-refundable once the subscription has been successfully activated.",
        ]}
      />
      <LegalCard
        heading="Verify Before Purchase"
        points={[
          "Before making a payment, users should carefully verify the selected plan, subscription duration, price, simulation option, and any applicable coupon or promotional offer.",
        ]}
      />
      <LegalCard
        heading="Activation Issues"
        points={[
          "If a payment is successfully completed but premium access is not activated due to a technical or payment-verification issue, the user should contact support with the payment or order reference. The issue will be investigated and access will be activated if the payment is verified.",
        ]}
      />
      <LegalCard
        heading="Duplicate or Failed Transactions"
        points={[
          "Duplicate payments, failed transactions, or payments deducted without successful order completion will be reviewed individually.",
        ]}
      />
      <LegalCard
        heading="Refund Processing"
        points={[
          "If a refund is approved, it will be processed according to the applicable payment method or payment provider's process.",
        ]}
      />
      <LegalCard
        heading="Coupons & Promotional Offers"
        points={[
          "Coupon discounts and promotional offers do not create any additional refund entitlement. Refund eligibility will be determined based on the actual payment and circumstances of the transaction.",
        ]}
      />
      <LegalCard
        heading="Simulation Credits"
        points={[
          "Simulation add-ons are digital credits. Once simulation credits have been successfully added to an account and used, they are non-refundable. Unused simulation credits remain subject to the platform's carry-forward rules.",
        ]}
      />
      <LegalCard
        heading="Contact Support"
        points={[
          "If a user experiences a payment, subscription, or access issue, they should contact the support email displayed on the website and provide the relevant account and payment or order reference.",
        ]}
      />
      <LegalCard
        heading="Fraud Investigation"
        points={[
          "The Quantum Minds reserves the right to investigate suspected fraudulent, abusive, or manipulated transactions before processing any refund.",
        ]}
      />
    </LegalPage>
  );
}